/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_LeadInputs */

const en_us2_quick_workout_lead = /** @type {(inputs: Quick_Workout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app picks the exercises from your time, your equipment and what has already recovered.`)
};

const pt_br2_quick_workout_lead = /** @type {(inputs: Quick_Workout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O app escolhe os exercícios pelo seu tempo, seu equipamento e o que já está recuperado.`)
};

const es_419_quick_workout_lead = /** @type {(inputs: Quick_Workout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La app elige los ejercicios según tu tiempo, tu equipo y lo que ya se recuperó.`)
};

const pt_pt2_quick_workout_lead = /** @type {(inputs: Quick_Workout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A app escolhe os exercícios pelo teu tempo, pelo teu equipamento e pelo que já está recuperado.`)
};

const fr_fr2_quick_workout_lead = /** @type {(inputs: Quick_Workout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'appli choisit les exercices selon ton temps, ton équipement et ce qui a déjà récupéré.`)
};

const de_de2_quick_workout_lead = /** @type {(inputs: Quick_Workout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die App wählt die Übungen nach deiner Zeit, deiner Ausrüstung und dem, was schon erholt ist.`)
};

const it_it2_quick_workout_lead = /** @type {(inputs: Quick_Workout_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'app sceglie gli esercizi in base al tuo tempo, alla tua attrezzatura e a ciò che si è già recuperato.`)
};

/**
* | output |
* | --- |
* | "The app picks the exercises from your time, your equipment and what has already recovered." |
*
* @param {Quick_Workout_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_lead = /** @type {((inputs?: Quick_Workout_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_lead(inputs)
	if (locale === "es-419") return es_419_quick_workout_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_lead(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_lead(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_lead(inputs)
	return en_us2_quick_workout_lead(inputs)
});
export { quick_workout_lead as "quick-workout.lead" }